import { alpha, buttonBaseClasses, styled } from '@mui/material'
import { Tabs } from '@mui/material'
import { colors } from '../theme/colors.theme'

export const tabsTheme = {
  root: {
    minHeight: 'auto',
    alignItems: 'center',
    '& .with-padding': {
      paddingTop: 10,
      paddingBottom: 10,
    },
    [`& .${buttonBaseClasses.root}`]: {
      color: `${alpha(colors.white, 0.4)}`,
      '&.Mui-selected': {
        color: `${colors.white} !important`,
      },
    },

    '& .MuiTabs-indicator': {
      backgroundColor: colors.white,
    },
  },
}

export const TabsIcon = styled(Tabs)({
  indicator: {
    display: 'none',
  },
})
